// ISO 639-1 http://www.loc.gov/standards/iso639-2/php/code_list.php

import store from 'client/store/store';
import { LOCALES } from './locales';
import { useEffect, useRef } from 'react';
import { useSubmit } from 'react-router';

export const getLocale = () => {
    const state = store.getState();
    return state?.locale?.current || LOCALES.ENGLISH;
};

export const useLocaleAutoSwitch = () => {
    const currentLocale = getLocale();
    const locale = useRef(currentLocale);
    const submit = useSubmit();

    useEffect(() => {
        if (locale?.current !== currentLocale) {
            submit(null);
        }
    }, [currentLocale]);
};

export const usePageLangAttribute = () => {
    const currentLocale = getLocale();
    useEffect(() => {
        document.documentElement.lang = currentLocale;
    }, [currentLocale]);
};
